import React, { FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ThunkDispatchType } from 'app/redux/types';

import { Modal } from 'app/design-system/components/Modal';
import { createSigningQuery } from 'app/modules/Signing/utils/signing-modals-query';

import { type CloseSigningDialog, closeSigningDialog } from './actions';
import ModalContent from './components';

const SigningDialog: FC = () => {
  const { search } = useLocation();
  const dispatch = useDispatch<ThunkDispatchType<CloseSigningDialog>>();

  const handleClose = useCallback(() => {
    dispatch(closeSigningDialog());
    sessionStorage.removeItem('phone');
  }, [search]);

  const isRegistration = search.startsWith(createSigningQuery('registration'));

  return (
    <Modal isOpen
           closable
           maxWidth={540}
           onClose={handleClose}
           isOutsideClickable={!isRegistration}
           data-test="Modal-Signing">
      <ModalContent />
    </Modal>
  );
};

export default memo(SigningDialog);
